import { RouteConfig } from 'vue-router';
import { tabRoutes } from '@/common/RouteUtils';
import { fuelTankTabs } from '@/pages/account/products/fuel/routes';
import { rawDataTabs } from '@/components/display/raw-data/raw-data-utils';

export const faultRoutes: RouteConfig[] = [
	{
		path: '/issues/faults/:productId',
		name: 'faults.view',
		component: () => import(/* webpackChunkName: "account" */ './view.vue'),
		meta: { auth: true },
		redirect: { name: 'faults.general' },
		children: [
			...tabRoutes('faults', [
				'general',
				'current',
				'past',
				'simpro',
				'users',
				'vats',
				'tanks/overview',
				'transceivers',
				'activity-log',
			]),
			{
				path: 'vats/:vatId',
				name: 'faults.vats.detail',
				meta: { auth: true },
				redirect: { name: 'faults.vats.detail.information' },
				children: tabRoutes('faults.vats.detail', ['information', 'change-log']),
			},
			{
				path: 'tanks/:tankId',
				name: 'faults.tanks.detail',
				meta: { auth: true },
				redirect: { name: 'faults.tanks.detail.general.information' },
				children: tabRoutes('faults.tanks.detail', fuelTankTabs),
			},
			{
				path: 'transceivers/:transceiverId',
				name: 'faults.transceivers.detail',
				meta: { auth: true },
				redirect: { name: 'faults.transceivers.detail.raw-data.all' },
				children: tabRoutes('faults.transceivers.detail', [
					...rawDataTabs.map(tab => `raw-data/${tab.path}`),
					'chart',
				]),
			},
		],
	},
];
